/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preset_Name_LabelInputs */



/**
* | output |
* | --- |
* | "Preset Name" |
*
* @param {Video_Export_Preset_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preset_name_label = /** @type {((inputs?: Video_Export_Preset_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preset_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du prereglage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Voreingestellter Name")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome predefinito")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название предустановки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del preajuste")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预设名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセット名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीसेट नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome predefinido")
	return /** @type {LocalizedString} */ ("Preset Name")
});